const Statistics = ({ totalBooks, averageRanking, bookNotStarted, bookStarted, bookFinished }) => {
    const stats = [
        { label: 'Total Books', value: totalBooks },
        { label: 'Avg Rating', value: averageRanking ? `${parseFloat(averageRanking).toFixed(1)}/10` : '—' },
        { label: 'In Progress', value: bookStarted },
        { label: 'Not Started', value: bookNotStarted },
        { label: 'Finished', value: bookFinished },
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mb-6">
            {stats.map(({ label, value }) => (
                <div key={label} className="bg-white rounded-2xl border border-warm-200 shadow-sm p-5 text-center">
                    <div className="font-serif text-3xl font-bold text-warm-800">{value ?? '—'}</div>
                    <div className="text-xs text-warm-400 mt-1.5 font-medium uppercase tracking-wide">{label}</div>
                </div>
            ))}
        </div>
    );
};

export default Statistics;
